import React from "react";
import "./homecard.css"
import {trackClick} from "../../../app/utils/Analytics";
import {Link} from "react-router-dom";
import NineCirclesIcon from "../../assets/NineCirclesIcon";

export default function HomeCardComponent({homeCardType, color, path, showAllNine}) {
    return (
        <Link className={"homeCard" + homeCardType + color} role="link" to={path.path} onClick={() => {
            trackClick("HomeCard -" + homeCardType, path.path)
        }}>
            <div aria-hidden={true} className="iconCircle">{path.icon()}</div>
            <h3>{path.name}</h3>
            <div className="cardBody">{path.tagline}</div>
            <NineCirclesIcon className={"homeCardNineCircles" + (showAllNine ? " showAllNine" : "")}
                             aria-hidden={true}/>
        </Link>
    );
}

export const HomeCardType = {
    Filled: " filled",
    Outlined: " outlined"
}

export const ThemeColor = {
    Primary: " primary",
    Secondary: " secondary",
    Tertiary: " tertiary",
    Success: " success",
    Warning: " warning",
    Danger: " danger",
    Light: " light",
    Info: " info",
    Dark: " dark"
}
